import { render, staticRenderFns } from "./staggering-transition-group.vue?vue&type=template&id=7f212c59&"
import script from "./staggering-transition-group.vue?vue&type=script&lang=ts&"
export * from "./staggering-transition-group.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports